import { provideZoneChangeDetection } from "@angular/core";
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import {
  CellSelectionModule,
  ClipboardModule,
  ColumnMenuModule,
  ColumnsToolPanelModule,
  ContextMenuModule,
  FiltersToolPanelModule,
  LicenseManager,
  ServerSideRowModelApiModule,
  ServerSideRowModelModule,
  SideBarModule,
  StatusBarModule,
} from 'ag-grid-enterprise';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Registra todos os módulos Community (nenhum risco: cobre tudo que já estava disponível
// antes) + só os módulos Enterprise que o app realmente usa hoje (confirmado por grep em todo
// o código): grid com dados no servidor, sidebar de colunas/filtros, barra de status, seleção
// de células e clipboard, e o menu de coluna/contexto. Recursos Enterprise não usados em lugar
// nenhum (agrupamento de linhas, pivot, master/detail, filtros avançados/set, dados em árvore,
// gráficos/sparklines, exportação Excel) ficam de fora — eram a maior parte do peso do
// `AllEnterpriseModule` anterior. Se algum grid usar um recurso Enterprise não listado aqui, o
// próprio AG Grid avisa no console do navegador qual módulo está faltando.
ModuleRegistry.registerModules([
  AllCommunityModule,
  ServerSideRowModelModule,
  // ServerSideRowModelModule por si só não expõe a API (refreshServerSide, etc.) — no v35 essa
  // API vive num módulo irmão separado. Sem isto, gridApi.refreshServerSide() é um no-op
  // silencioso (sem erro, sem requisição nova), o que fazia a grade nunca atualizar sozinha
  // após excluir um registro em nenhuma tela do app.
  ServerSideRowModelApiModule,
  SideBarModule,
  ColumnsToolPanelModule,
  FiltersToolPanelModule,
  StatusBarModule,
  CellSelectionModule,
  ClipboardModule,
  ColumnMenuModule,
  ContextMenuModule,
]);

if (environment.agGridLicenseKey) {
  LicenseManager.setLicenseKey(environment.agGridLicenseKey);
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch((err: unknown) => console.error(err));
